import { render, staticRenderFns } from "./ManageProductPage.vue?vue&type=template&id=d006940c&scoped=true&"
import script from "./ManageProductPage.vue?vue&type=script&lang=js&"
export * from "./ManageProductPage.vue?vue&type=script&lang=js&"
import style0 from "./ManageProductPage.vue?vue&type=style&index=0&id=d006940c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d006940c",
  null
  
)

export default component.exports